import { render, staticRenderFns } from "./SenderIdVerification.vue?vue&type=template&id=a5cd8d04&"
import script from "./SenderIdVerification.vue?vue&type=script&lang=js&"
export * from "./SenderIdVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports